import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import classes from './UnsubsribePage.module.scss';
import MainButton from '../../Components/common/buttons/MainButton';
import { editJobAlert, getAllJobAlerts, unsubscribeJobAlert } from '../../actions/jobAlerts';
import colors from '../../scss/colors';

export default function UnsubscribePage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const { alerts, updatePending, updateError, unsubscribePending } = useSelector((state) => state.jobAlerts);
  const [alertUpdated, setAlertUpdated] = useState(false);
  const [allAlertUpdated, setAllAlertUpdated] = useState(false);

  const unsubscribeJobAlertById = () => {
    const id = params?.id;
    const updatedAlert = alerts.find((alert) => alert?.Id === Number(id));

    updatedAlert.isActive = false;

    dispatch(editJobAlert(updatedAlert));

    if (!updatePending && !updateError) {
      setAlertUpdated(true);
    } else {
      setAlertUpdated(false);
    }
  };

  const unsubscribeAllJobAlerts = () => {
    dispatch(unsubscribeJobAlert(false));

    if (!unsubscribePending) {
      setAllAlertUpdated(true);
    } else {
      setAllAlertUpdated(false);
    }
  };

  useEffect(() => {
    dispatch(getAllJobAlerts());
  }, []);

  const renderContent = () => {
    if (alertUpdated)
      return <span className={classes.navyBlueMessage}>{t('jobs.unsubscribe.unsubscribed_message')}</span>;

    if (allAlertUpdated)
      return <span className={classes.navyBlueMessage}>{t('jobs.unsubscribe.unsubscribe_all_success')}</span>;

    return (
      <>
        <span>{t('jobs.unsubscribe.subtitle_1')}</span>
        <Link to="/dashboard/settings?tab=emailnotifications"> {t('jobs.unsubscribe.subtitle_2')} </Link>
        <span>{t('jobs.unsubscribe.subtitle_3')}</span>
      </>
    );
  };

  const renderFooterContainer = () => {
    if (allAlertUpdated) return null;
    if (alertUpdated)
      return (
        <>
          <span className={classes.divider}>&nbsp;</span>
          <span className={classes.footerContent}>{t('jobs.unsubscribe.unsubscribe_all_message')}</span>
          <MainButton
            sx={{ color: colors.BRAND_BLUE, fontWeight: 'normal', textDecoration: 'underline' }}
            forceWidth="100%"
            variant="text"
            size="xmedium"
            action={unsubscribeAllJobAlerts}
          >
            {t('jobs.unsubscribe.unsubscribe_all')}
          </MainButton>
        </>
      );

    return (
      <MainButton forceWidth="100%" size="medium" action={unsubscribeJobAlertById} rounded>
        {t('jobs.unsubscribe.button')}
      </MainButton>
    );
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <h1>{!alertUpdated || !allAlertUpdated ? t('jobs.unsubscribe.title') : t('jobs.unsubscribe.unsubscribed')}</h1>
        <div className={classes.content}>{renderContent()}</div>
        <div className={classes.footerContainer}>{renderFooterContainer()}</div>
      </div>
    </div>
  );
}
